<template>
    <router-view />
</template>

<script>
    export default {
        name: "StoreMallLayout"
    }
</script>

<style scoped>

</style>